module.exports = __webpack_public_path__ + "img/once_ar.8ef64947.png";